import { AxiosPromise } from 'axios';

import { Urls } from '@share/constants';
import {
  IIssueReportContext,
  IIssueReportResponse,
  ISSUE_REPORT_MAX_IMAGES,
} from '@share/common-types';

import { axiosInstanceB2B } from '@share/utils';
import { sanitizeUrl } from '../utils/redact';

export interface IIssueReportRequest {
  context: IIssueReportContext;
  comment: string;
  images: File[];
}

// multipart/form-data only: the endpoint has no JSON body. userId, accountId,
// userEmail and memberId are read from the JWT server-side, so they are not sent.
export const buildIssueReportFormData = ({
  context,
  comment,
  images,
}: IIssueReportRequest): FormData => {
  const formData = new FormData();

  formData.append('bookingEngine', context.bookingEngine);
  formData.append('payload', JSON.stringify(context.payload));
  formData.append('sessionId', context.sessionId);
  formData.append('step', context.step);
  formData.append('comment', comment);
  formData.append('url', sanitizeUrl(window.location.href));

  images.slice(0, ISSUE_REPORT_MAX_IMAGES).forEach((image) => {
    formData.append('images', image, image.name);
  });

  return formData;
};

export const IssueReportsAPI = {
  create(request: IIssueReportRequest): AxiosPromise<IIssueReportResponse> {
    return axiosInstanceB2B.post(Urls.IssueReports, buildIssueReportFormData(request), {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};
